import React from 'react';

const MailingAddress = () => (
  <p className="va-address-block">
    U.S. Department of Veterans Affairs
    <br />
    Pension Intake Center
    <br />
    PO Box 5365
    <br />
    Janesville, WI 53547-5365
    <br />
  </p>
);

export default MailingAddress;
